import React from 'react';
import './AGB.css';

const AGB = () => {
  return (
    <div className="agb-container">
      <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>

      <section className="agb-section">
        <h2>1. Geltungsbereich</h2>
        <p>
          Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge über Umzugs-, Transport-,
          Lagerungs- und Einpackleistungen sowie damit verbundene Dienstleistungen zwischen
          SaveMove Umzüge (Inhaber: Hasan Al Mohamad) und ihren Kunden.
        </p>
      </section>

      <section className="agb-section">
        <h2>2. Angebot und Vertragsschluss</h2>
        <p>
          2.1. Angebote von SaveMove Umzüge sind freibleibend, sofern sie nicht ausdrücklich als verbindlich gekennzeichnet sind.<br />
          2.2. Ein Vertrag kommt durch die schriftliche Bestätigung (auch per E-Mail oder Messenger) des Angebots durch den Kunden zustande.
        </p>
      </section>

      <section className="agb-section">
        <h2>3. Leistungsumfang und Mitwirkungspflichten</h2>
        <p>
          3.1. Der Umfang der zu erbringenden Leistungen ergibt sich aus dem jeweiligen Angebot oder Leistungsvertrag.<br />
          3.2. Der Auftraggeber ist verpflichtet, alle zur ordnungsgemäßen Durchführung des Auftrags erforderlichen Angaben (z. B. Belade- und Entladestellen, Stockwerke, Fahrstuhlnutzung, besondere Wertgegenstände oder Gefahrgut) wahrheitsgemäß und vollständig zu machen.<br />
          3.3. Der Auftraggeber sorgt dafür, dass die Be- und Entladewege frei zugänglich sind und gegebenenfalls erforderliche Halteverbotszonen rechtzeitig eingerichtet oder beantragt wurden.
        </p>
      </section>

      <section className="agb-section">
        <h2>4. Preise und Zahlungsbedingungen</h2>
        <p>
          4.1. Es gelten die im Vertrag vereinbarten Preise.<br />
          4.2. Sofern nicht anders vereinbart, ist die Vergütung unmittelbar nach Erbringung der Dienstleistung in bar oder per EC-/Kreditkarte vor Ort fällig.<br />
          4.3. Zusatzleistungen, die nicht im ursprünglichen Angebot enthalten waren (z. B. zusätzliche Möbelstücke, Verzögerungen durch fehlende Be-/Entlademöglichkeiten), werden gesondert berechnet.
        </p>
      </section>

      <section className="agb-section">
        <h2>5. Rücktritt und Kündigung (Stornierung)</h2>
        <p>
          Der Kunde kann den Vertrag jederzeit kündigen. Bei Kündigung ohne Verschulden von SaveMove Umzüge gelten folgende Stornogebühren:
        </p>
        <ul>
          <li>Bis 14 Tage vor dem vereinbarten Umzugstermin: kostenfrei.</li>
          <li>13 bis 7 Tage vor dem Termin: 25 % des vereinbarten Gesamtpreises.</li>
          <li>6 bis 2 Tage vor dem Termin: 50 % des vereinbarten Gesamtpreises.</li>
          <li>Weniger als 48 Stunden vor dem Termin oder bei Nichterscheinen: 80 % des vereinbarten Gesamtpreises.</li>
        </ul>
      </section>

      <section className="agb-section">
        <h2>6. Haftung und Haftungsbegrenzung</h2>
        <p>
          6.1. Die Haftung für Transport- und Umzugsschäden richtet sich nach den gesetzlichen Bestimmungen des Handelsgesetzbuches (§§ 451 ff. HGB).<br />
          6.2. Die Haftung des Frachtführers wegen Verlust oder Beschädigung ist auf einen Betrag von 620,00 Euro je Kubikmeter Rauminhalt, der zur Erfüllung des Vertrages benötigt wird, begrenzt.<br />
          6.3. Keine Haftung besteht für Schäden an Gegenständen, die vom Kunden selbst verpackt wurden, es sei denn, das Ausmaß der Beschädigung ist auf grobe Fahrlässigkeit oder Vorsatz von SaveMove Umzüge zurückzuführen.<br />
          6.4. Für Schäden an empfindlichen elektronischen Geräten, Pflanzen oder bereits beschädigten Möbelstücken wird keine Haftung übernommen, soweit der Schaden nicht vorsätzlich oder grob fahrlässig verursacht wurde.
        </p>
      </section>

      <section className="agb-section">
        <h2>7. Schadensanzeige</h2>
        <p>
          7.1. Offensichtliche Schäden sind unmittelbar bei der Übergabe/Ablieferung gegenüber den Mitarbeitern von SaveMove Umzüge schriftlich anzuzeigen.<br />
          7.2. Nicht offensichtliche Schäden sind innerhalb von 7 Tagen nach Ablieferung detailliert schriftlich anzuzeigen (§ 451f HGB). Nach Ablauf dieser Frist erlöschen etwaige Schadensersatzansprüche.
        </p>
      </section>

      <section className="agb-section">
        <h2>8. Schlussbestimmungen</h2>
        <p>
          8.1. Es gilt das Recht der Bundesrepublik Deutschland.<br />
          8.2. Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen davon unberührt.
        </p>
      </section>
    </div>
  );
};

export default AGB;